/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { Link } from '@dataplace.ai/ui-components/atoms'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Description } from '../ChainBenchmark.styles'

interface ChainBenchmarkDescriptionComponentProps {
  firstDescription: string
  secondDescription: string
}

function ChainBenchmarkDescriptionComponent({
  firstDescription, secondDescription,
}: ChainBenchmarkDescriptionComponentProps) {
  const { t } = useTranslation()

  return (
    <span>
      <Description>{t(firstDescription)}</Description>
      {' '}
      <Link
        href={`${process.env.NX_WEBAPP3_URL}/chain/kanban`}
        target='_blank'
      >
        {t('generic.my_chain')}
      </Link>
      {' '}
      <Description>{t(secondDescription)}</Description>
    </span>
  )
}

export default ChainBenchmarkDescriptionComponent
